/**
 * 系统管理  公司管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>公司管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <!-- <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.name" placeholder="输入公司名称"></el-input>
      </el-form-item> -->
      <!-- <el-form-item label=""> -->
        <!-- <el-input size="small" v-model="formInline.deptNo" placeholder="输入公司代码"></el-input> -->
      <!-- </el-form-item> -->
      <el-form-item>
        <!-- <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button> -->
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加公司</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" type="selection" width="60">
      </el-table-column>
      <el-table-column sortable prop="name" label="公司名称" width="300">
      </el-table-column>
      <el-table-column sortable prop="name_id" label="公司代码" width="300">
      </el-table-column>
      <!-- <el-table-column sortable prop="editTime" label="修改时间" width="300">
        <template slot-scope="scope">
          <div>{{scope.row.editTime|timestampToTime}}</div>
        </template>
      </el-table-column>
      <el-table-column sortable prop="editUser" label="修改人" width="300">
      </el-table-column> -->
      <el-table-column align="center" label="操作" min-width="300">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="deleteUser(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="30%" @click="closeDialog">
      <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
        <el-form-item label="公司名称" prop="name">
          <el-input size="small" v-model="editForm.name" auto-complete="off" placeholder="请输入公司名称"></el-input>
        </el-form-item>
        <!-- <el-form-item label="公司代码" prop="name_id">
          <el-input size="small" v-model="editForm.name_id" auto-complete="off" :disabled="keyEdit" placeholder="请输入公司代码"></el-input>
        </el-form-item> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import { deptList, deptSave, deptDelete } from '../../api/userMG'
import Pagination from '../../components/Pagination'
import {getCompanyList,addCompanyList,editCompanyList,delCompanyList} from '../../api/newApis'
export default {
  data() {
    return {
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '添加',
      keyEdit:false,
      editForm: {
        name: '',
        name_id: '',
        // deptNo: '',
        token: localStorage.getItem('logintoken')
      },
      // rules表单验证
      rules: {
        deptName: [
          { required: true, message: '请输入公司名称', trigger: 'blur' }
        ],
        deptNo: [{ required: true, message: '请输入公司代码', trigger: 'blur' }]
      },
      formInline: {
        page: 1,
        limit: 10,
        name:"",
        // varLable: '',
        // varName: '',
        token: localStorage.getItem('logintoken')
      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getCompanyList()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取公司列表
    // getdata(parameter) {
    //   this.loading = true
    //   // 模拟数据
    //   let res = {
    //     code: 0,
    //     msg: null,
    //     count: 5,
    //     data: [
    //       {
    //         addUser: null,
    //         editUser: null,
    //         addTime: 1521062371000,
    //         editTime: 1526700200000,
    //         deptId: 2,
    //         deptName: '上海分公司',
    //         deptNo: '1',
    //         parentId: 1
    //       },
    //       {
    //         addUser: null,
    //         editUser: null,
    //         addTime: 1521063247000,
    //         editTime: 1526652291000,
    //         deptId: 3,
    //         deptName: '上海测试',
    //         deptNo: '02',
    //         parentId: 1
    //       },
    //       {
    //         addUser: null,
    //         editUser: null,
    //         addTime: 1526349555000,
    //         editTime: 1526349565000,
    //         deptId: 12,
    //         deptName: '1',
    //         deptNo: '11',
    //         parentId: 1
    //       },
    //       {
    //         addUser: null,
    //         editUser: null,
    //         addTime: 1526373178000,
    //         editTime: 1526373178000,
    //         deptId: 13,
    //         deptName: '5',
    //         deptNo: '5',
    //         parentId: 1
    //       },
    //       {
    //         addUser: null,
    //         editUser: null,
    //         addTime: 1526453107000,
    //         editTime: 1526453107000,
    //         deptId: 17,
    //         deptName: 'v',
    //         deptNo: 'v',
    //         parentId: 1
    //       }
    //     ]
    //   }
    //   this.loading = false
    //   this.listData = res.data
    //   // 分页赋值
    //   this.pageparm.currentPage = this.formInline.page
    //   this.pageparm.pageSize = this.formInline.limit
    //   this.pageparm.total = res.count
    //   // 模拟数据结束

    //   /***
    //    * 调用接口，注释上面模拟数据 取消下面注释
    //    */
    //   // deptList(parameter)
    //   //   .then(res => {
    //   //     this.loading = false
    //   //     if (res.success == false) {
    //   //       this.$message({
    //   //         type: 'info',
    //   //         message: res.msg
    //   //       })
    //   //     } else {
    //   //       this.listData = res.data
    //   //       // 分页赋值
    //   //       this.pageparm.currentPage = this.formInline.page
    //   //       this.pageparm.pageSize = this.formInline.limit
    //   //       this.pageparm.total = res.count
    //   //     }
    //   //   })
    //   //   .catch(err => {
    //   //     this.loading = false
    //   //     this.$message.error('菜单加载失败，请稍后再试！')
    //   //   })
 


    // },
    async getCompanyList(params) {
      console.log(22222222,params);
      let res = await getCompanyList(params)
      this.listData = res.data
      console.log(this.listData);
      // this.pageparm.total = res.data.total
      // this.pageparm.pageSize = res.data.pageSize
      // this.pageparm.index = res.data.index
    },
    // 分页插件事件
    callFather(parm) {
      // this.formInline.page = parm.currentPage
      // this.formInline.limit = parm.pageSize
      // this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.getCompanyList(this.formInline)
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.keyEdit = true
        this.title = '修改'
        this.editForm.name = row.name
        this.editForm.name_id = row.name_id
        // this.editForm.deptNo = row.deptNo
      } else {
        this.keyEdit = false
        this.title = '添加'
        this.editForm.name = ''
        this.editForm.name_id = ''
        // this.editForm.deptNo = ''
      }
    },
    // 新增
    async submitForm(){
      console.log(5555555,this.title);
      if(this.title == '添加'){
        let res = await addCompanyList(this.editForm)
        console.log(33333333,res);
        if(res.code == 200) {
          this.$message.success("新增成功!")
          this.getCompanyList()
          this.editFormVisible = false
          this.loading = false
        }else{
          this.$message.error(res.msg)
        }
      }else{
        let res = await editCompanyList(this.editForm)
        console.log(33333333,res);
        if(res.code == 200) {
          this.$message.success("修改成功!")
          this.getCompanyList()
          this.editFormVisible = false
          this.loading = false
        }else{
          this.$message.error(res.msg)
        }
      }
    },

    // 编辑
    // async submitEditForm(){
    //   let res = await addCompanyList(this.editForm)
    //   console.log(33333333,res);
    //   if(res.code == 200) {
    //     this.$message.success("新增成功!")
    //     this.editFormVisible = false
    //     this.loading = false
    //   }else{
    //     this.$message.error(res.msg)
    //   }
    // },

    // 编辑、增加页面保存方法
    // submitForm(editData) {
    //   this.$refs[editData].validate(valid => {
    //     console.log(editData,333333);
    //     if (valid) {
    //       addCompanyList(this.editForm)
    //         .then(res => {
    //           this.editFormVisible = false
    //           this.loading = false
    //           console.log(2222,res);


    //           if (res.success) {
    //             this.getCompanyList()
    //             this.$message({
    //               type: 'success',
    //               message: '公司保存成功！'
    //             })
    //           } else {
    //             this.$message({
    //               type: 'info',
    //               message: res.msg
    //             })
    //           }
    //         })
    //         .catch(err => {
    //           this.editFormVisible = false
    //           this.loading = false
    //           this.$message.error('公司保存失败，请稍后再试！')
    //         })
    //     } else {
    //       return false
    //     }
    //   })
    // },
    // 删除公司
    deleteUser(index, row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async ()=>{
        let res = await delCompanyList(row.name_id + "")
      if (res.code == 200) {
        this.$message.success("删除成功")
        this.getCompanyList()
      } else {
        this.$message.error(res.msg)
      }
      }).catch(()=>{
        this.$message.error("已取消删除")
      })
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>

 


// WEBPACK FOOTER //
// src/views/system/Dept.vue